import React from 'react';
import Styles from './styles.module.css';
import Loader from '../../assets/svg/loader.svg';

const AddressSelector = ({ 
    addresses, 
    selectedBillingAddress, 
    selectedShippingAddress,
    onBillingAddressSelect,
    onShippingAddressSelect, 
    isLoading, 
    customer 
}) => {
    const handleBillingAddressClick = (address) => {
        console.log('[Address Select] Billing address selected:', address);
        onBillingAddressSelect(address);
    };

    const handleShippingAddressClick = (address) => {
        console.log('[Address Select] Shipping address selected:', address);
        onShippingAddressSelect(address);
    };

    const getAddressDisplay = (address) => {
        const parts = [
            address.street,
            address.zipcode,
            address.city,
            address.country?.name
        ].filter(Boolean);
        return parts.join(', ');
    };

    const isDefaultAddress = (address, type) => {
        if (type === 'billing') {
            return customer?.defaultBillingAddressId === address.id;
        }
        if (type === 'shipping') {
            return customer?.defaultShippingAddressId === address.id;
        }
        return false;
    };

    return (
        <div className={Styles.container}>
            <div className={Styles.card}>
                <h3 className={Styles.title}>Adressen auswählen</h3>
                
                {isLoading ? (
                    <div className={Styles.loading}>
                        <img src={Loader} width={30} height={30} alt="Loading" />
                        <span>Lade Adressen...</span>
                    </div>
                ) : addresses.length === 0 ? (
                    <div className={Styles.noAddresses}>
                        <p>Keine Adressen für diesen Kunden gefunden.</p>
                    </div>
                ) : (
                    <div className={Styles.addressSelection}>
                        <div className={Styles.addressTypes}>
                            <div className={Styles.addressType}>
                                <h4>Rechnungsadresse</h4>
                                <div className={Styles.addressGrid}>
                                    {addresses.map((address, index) => (
                                        <div
                                            key={`billing-${address.id}-${index}`}
                                            className={`${Styles.addressCard} ${
                                                selectedBillingAddress?.id === address.id ? Styles.selectedBilling : ''
                                            }`}
                                            onClick={() => handleBillingAddressClick(address)}
                                        >
                                            <div className={Styles.addressDetails}>
                                                <div className={Styles.addressLine}>
                                                    <strong>
                                                        {address.firstName} {address.lastName}
                                                    </strong>
                                                    {address.company && (
                                                        <span className={Styles.company}>
                                                            ({address.company})
                                                        </span>
                                                    )}
                                                </div>
                                                <div className={Styles.addressLine}>
                                                    {getAddressDisplay(address)}
                                                </div>
                                                {address.phoneNumber && (
                                                    <div className={Styles.phoneNumber}>
                                                        Tel: {address.phoneNumber}
                                                    </div>
                                                )}
                                            </div>
                                            <div className={Styles.addressFlags}>
                                                {isDefaultAddress(address, 'billing') && (
                                                    <span className={`${Styles.flag} ${Styles.billing}`}>
                                                        Standard
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className={Styles.addressType}>
                                <h4>Versandadresse</h4>
                                <div className={Styles.addressGrid}>
                                    {addresses.map((address, index) => (
                                        <div
                                            key={`shipping-${address.id}-${index}`}
                                            className={`${Styles.addressCard} ${
                                                selectedShippingAddress?.id === address.id ? Styles.selectedShipping : ''
                                            }`}
                                            onClick={() => handleShippingAddressClick(address)}
                                        >
                                            <div className={Styles.addressDetails}>
                                                <div className={Styles.addressLine}>
                                                    <strong>
                                                        {address.firstName} {address.lastName}
                                                    </strong>
                                                    {address.company && (
                                                        <span className={Styles.company}>
                                                            ({address.company})
                                                        </span>
                                                    )}
                                                </div>
                                                <div className={Styles.addressLine}>
                                                    {getAddressDisplay(address)}
                                                </div>
                                                {address.phoneNumber && (
                                                    <div className={Styles.phoneNumber}>
                                                        Tel: {address.phoneNumber}
                                                    </div>
                                                )}
                                            </div>
                                            <div className={Styles.addressFlags}>
                                                {isDefaultAddress(address, 'shipping') && (
                                                    <span className={`${Styles.flag} ${Styles.shipping}`}>
                                                        Standard
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {(selectedBillingAddress || selectedShippingAddress) && (
                    <div className={Styles.selectedAddresses}>
                        {selectedBillingAddress && (
                            <div className={Styles.selectedAddress}>
                                <h4>Ausgewählte Rechnungsadresse:</h4>
                                <div className={Styles.addressSummary}>
                                    <p><strong>{selectedBillingAddress.firstName} {selectedBillingAddress.lastName}</strong></p>
                                    {selectedBillingAddress.company && (
                                        <p><em>{selectedBillingAddress.company}</em></p>
                                    )}
                                    <p>{selectedBillingAddress.street}</p>
                                    <p>{selectedBillingAddress.zipcode} {selectedBillingAddress.city}</p>
                                    <p>{selectedBillingAddress.country?.name}</p>
                                    {selectedBillingAddress.phoneNumber && (
                                        <p>Tel: {selectedBillingAddress.phoneNumber}</p>
                                    )}
                                </div>
                            </div>
                        )}

                        {selectedShippingAddress && (
                            <div className={Styles.selectedAddress}>
                                <h4>Ausgewählte Versandadresse:</h4>
                                <div className={Styles.addressSummary}>
                                    <p><strong>{selectedShippingAddress.firstName} {selectedShippingAddress.lastName}</strong></p>
                                    {selectedShippingAddress.company && (
                                        <p><em>{selectedShippingAddress.company}</em></p>
                                    )}
                                    <p>{selectedShippingAddress.street}</p>
                                    <p>{selectedShippingAddress.zipcode} {selectedShippingAddress.city}</p>
                                    <p>{selectedShippingAddress.country?.name}</p>
                                    {selectedShippingAddress.phoneNumber && (
                                        <p>Tel: {selectedShippingAddress.phoneNumber}</p>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AddressSelector;